import Hotjar from '@hotjar/browser';
import { HotJarEventName } from './HotJarEvents';


const HotjarWrapper = {
  init: function () {
    Hotjar.init(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_VERSION, {
      debug: process.env.REACT_APP_HOTJAR_DEBUG === 'true',
    });
  },
  event: function (event: HotJarEventName) {
    if (Hotjar.isReady()) {
      Hotjar.event(event);
    }
  }
};

export default HotjarWrapper;
